import { WalletRefund } from '@/model/WalletRefund';
import { CRUD } from './base/crud';

class WalletRefundsService extends CRUD<WalletRefund, any> {
    readonly endPoint = 'admin/wallet-refunds';

    async exportExcel(filters: any): Promise<any> {
        const params = { ...filters };
        // Rimuove parametri di paginazione
        delete params.first;
        delete params.rows;
        delete params.page;
        delete params.per_page;
        
        return this.get(`${this.endPoint}/export`, {
            params,
            responseType: 'blob'
        });
    }
}

export const walletRefundsService = new WalletRefundsService();
